export default __webpack_public_path__ + "static/media/motorcycle.ad7faa63.svg";